var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import { screenTypeDetect } from '../../utils/screen-type-detect';
import { Throttler } from '../../throttler';
import { DESKTOP_NAME, MOBILE_NAME, TABLET_NAME } from './constants';
var DEFAULT_THROTTLE_TIMEOUT = 300;
export var withScreenResizeDetectHoc = function (_a) {
    var throttleTimeout = _a.throttleTimeout, initialStateGetter = _a.initialStateGetter, orientationChangeTimeout = _a.orientationChangeTimeout, withWidthCapture = _a.withWidthCapture;
    return function (Component) {
        var _a;
        return _a = /** @class */ (function (_super) {
                __extends(class_1, _super);
                function class_1(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleChangeOrientation = function () {
                        var isMobile = matchMedia('(max-width: 480px)').matches;
                        if (_this.state.screenType === DESKTOP_NAME ||
                            (_this.state.screenType === MOBILE_NAME && isMobile)) {
                            return;
                        }
                        if (isMobile) {
                            _this.setState({
                                screenType: MOBILE_NAME,
                                windowWidth: window.innerWidth,
                            });
                            return;
                        }
                        _this.setState({
                            screenType: TABLET_NAME,
                            windowWidth: window.innerWidth,
                        });
                    };
                    _this.handleResize = function () {
                        var windowWidth = window.innerWidth;
                        var screenType = screenTypeDetect(windowWidth);
                        if (_this.state.windowWidth !== windowWidth) {
                            _this.setState({ windowWidth: windowWidth, screenType: screenType });
                        }
                    };
                    _this.state = {
                        windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
                        screenType: initialStateGetter
                            ? initialStateGetter()
                            : screenTypeDetect(window.innerWidth),
                    };
                    var throttler = new Throttler();
                    _this.throttledHandleResize = throttler.createThrottle({
                        callback: _this.handleResize,
                        timeoutMs: throttleTimeout || DEFAULT_THROTTLE_TIMEOUT,
                    });
                    _this.throttledHandleChangeOrientation = throttler.createThrottle({
                        callback: _this.handleChangeOrientation,
                        timeoutMs: orientationChangeTimeout || DEFAULT_THROTTLE_TIMEOUT + 10,
                    });
                    return _this;
                }
                class_1.prototype.componentDidMount = function () {
                    window.addEventListener('resize', this.throttledHandleResize);
                    window.addEventListener('orientationchange', this.throttledHandleChangeOrientation);
                };
                class_1.prototype.componentWillUnmount = function () {
                    window.removeEventListener('resize', this.throttledHandleResize);
                    window.removeEventListener('orientationchange', this.throttledHandleChangeOrientation);
                };
                class_1.prototype.render = function () {
                    return withWidthCapture ? (React.createElement(Component, __assign({}, this.props, { screenType: this.state.screenType, windowWidth: this.state.windowWidth }))) : (React.createElement(Component, __assign({}, this.props, { screenType: this.state.screenType })));
                };
                return class_1;
            }(PureComponent)),
            _a.displayName = 'withScreenResizeDetectHoc',
            _a;
    };
};
